import { Injectable } from '@angular/core';
import { PointFeature } from '@models/point';

@Injectable({
  providedIn: 'root'
})
export class MarkerContentService {

  constructor() { }

  getAsElement(pt: PointFeature) {
    const ptDetail = document.createElement('advanced-marker-content');

    ptDetail.pt = pt;
    return ptDetail;
  }
}
